<script>
	export let options = [];
	export let value = null;
</script>

<div class="buttons">
	{#each options as o}
		<div
			class="button"
			class:active={o.value === value}
			on:click={() => {
				value = o.value;
			}}
		>
			<slot option={o} active={o.value === value} />
		</div>
	{/each}
</div>

<style lang="scss">
	@import "../main.scss";

	.buttons {
		text-align: center;
		display: flex;
		flex-direction: row;
		background: #ffffff;
		box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.15);
		border-radius: 8px;
		text-align: center;
		overflow: hidden;
	}

	.button {
		position: relative;
		white-space: nowrap;
		user-select: none;
		-webkit-tap-highlight-color: transparent;
		cursor: pointer;
		transition: transform 0.4s cubic-bezier(0.68, -0.6, 0.32, 1.6);
		transform-origin: center center;
		transform: scale(1);
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		opacity: 0.7;
		transition: opacity 0.3s ease;

		&:first-child {
			border-right: 2px solid rgba($grey, 0.5);
		}
	}

	.button div {
		z-index: 1;
		position: relative;
	}

	.button::before {
		content: " ";
		position: absolute;
		bottom: 0;
		width: 100%;
		left: 0;
    background-color: $black;
    opacity: 0.188;
    height: 5px;
    transform: scaleY(0.6);
    transform-origin: center bottom;
		border-radius: 0;
    transition: transform 0.3s ease, opacity 0.3s ease;
	}

	.button.active {
		pointer-events: none;
		font-weight: $medium;
		opacity: 1;
	}

	.button.active::before {
    background-color: $black;
    transform: scaleY(1);
    opacity: 1;
	}

	.button:not(.active):hover::before {
    transform: scaleY(1);
	}

	// > large/normal phones
	@media (min-width: #{$breakpoint-mobile-l + 1px}) {
		.button {
			min-width: 156px;
		}
	}

	// small phones - large/normal phones
	@media (min-width: #{$breakpoint-mobile-s + 1px}) and (max-width: $breakpoint-mobile-l) {
		.button {
			min-width: 142px;
		}
	}

	// <= small phones
	@media (max-width: $breakpoint-mobile-s) {
		.button {
			min-width: unset;
			width: 50%;
			padding: 7px 12px 12px 13px !important;
		}
	}

	// > small tablets
	@media (min-width: #{$breakpoint-tablet-s + 1px}) {
		.button {
			padding: 13px 22px 18px 22px;
		}
	}

	// <= small tablets
	@media (max-width: $breakpoint-tablet-s) {
		.button {
			padding: 10px 18px 18px 18px;
		}
	}
</style>
